module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_11"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "text_5"
  }, [_vm._v("When the truths of the world become all too real, I pray the elusiveness of things unknown lift you far and away from here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }, [_vm._v("—S.M. Atlas")]), _vm._v(" "), _c('p', {
    staticClass: "block_16",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75eb597b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0